import {fetchPost, generateEndpoint} from "../../../utils/request";

export const createCase = async ({ token, creatingCase }) => {
  const url = `${generateEndpoint('createCase')}`
  return fetchPost(url, token, { creatingCase })
}